<template>
  <div>
    <page-header>
      <template #title>
        <h1 class="page-title">{{ occupant ? 'Edit' : 'Add' }} Occupant</h1>
      </template>
    </page-header>
    <div class="row">
      <div class="col-lg-12">
        <div class="card mb-3">
          <div class="card-body">
            <div class="col-lg-6">
              <selectlist
                :options="types"
                v-model="form.type_id"
                label="Occupant Type"
                name="type"
                helper="Please select the type of occupant"
                placeholder="Please Select"
              ></selectlist>

              <inputbox
                v-model="form.first_name"
                name="first_name"
                label="First Name"
                helper="Please enter the first name of the occupant"
              ></inputbox>

              <inputbox
                v-model="form.last_name"
                name="last_name"
                label="Last Name"
                helper="Please enter the last name of the occupant"
              ></inputbox>

              <date-of-birth
                :required="true"
                v-model="form.date_of_birth"
                :unlimited="true"
                helper="Please enter the occupants date of birth"
              ></date-of-birth>

              <inputbox
                v-model="form.occupation"
                name="occupation"
                label="Occupation"
                helper="Please enter the occupation of the occupant"
              ></inputbox>

              <toggleswitch
                :labels="true"
                name="requires_glasses"
                label="Requires Glasses?"
                helper="Does the occupant require glasses for driving?"
                v-model="form.requires_glasses"
              ></toggleswitch>

              <toggleswitch
                :labels="true"
                name="wearing_seatbelt"
                label="Wearing Seatbelt?"
                helper="Was the occupant wearing a seatbelt when the accident occurred?"
                v-model="form.wearing_seatbelt"
              ></toggleswitch>

              <fieldset>
                <legend>
                  Contact Details
                  <small class="text-muted"
                    >- Enter the occupants contact details here
                  </small>
                </legend>

                <inputbox
                  v-model="form.telephone"
                  name="telephone"
                  label="Telephone"
                  helper="Please enter a contact telephone number for the occupant"
                ></inputbox>

                <inputbox
                  v-model="form.email_address"
                  name="email"
                  label="Email Address"
                  type="email"
                  helper="Please enter the email address for the occupant"
                ></inputbox>
              </fieldset>
            </div>
            <div class="col-lg-6">
              <inputbox
                v-model="form.medical_conditions"
                name="medical_conditions"
                helper="If the occupant has any medial conditions, please enter them here"
                label="Medical Conditions"
              ></inputbox>

              <inputbox
                v-model="form.relation_to_client"
                name="relation_to_client"
                helper="What is the occupants relationship with the client?"
                label="Relation to Client"
              ></inputbox>

              <inputbox
                v-model="form.national_insurance"
                name="national_insurance_number"
                helper="Please enter the occupants national insurance number"
                label="National Insurance Number"
              ></inputbox>

              <selectlist
                :options="positions"
                v-model="form.position_id"
                label="Seat/Position"
                name="position"
                helper="What position in the vehicle was the occupant in?"
                placeholder="Please Select"
              ></selectlist>

              <fieldset>
                <legend>
                  Address Details
                  <small class="text-muted"
                    >- Enter the occupants address details here
                  </small>
                </legend>
                <address-lookup
                  :address="address"
                  v-on:address="setAddress"
                ></address-lookup>
              </fieldset>
            </div>
          </div>
          <div class="card-footer text-right">
            <button
              class="btn btn-danger btn-raised float-left"
              name="delete"
              v-on:click.prevent="deleteOccupant"
              v-if="occupant"
            >
              <i class="icon icon-delete"></i> Delete
            </button>
            <button
              class="btn btn-primary btn-raised"
              name="cancel"
              v-on:click.prevent="cancel"
            >
              <i class="icon icon-cancel"></i> Back
            </button>
            <button
              class="btn btn-primary btn-raised"
              name="save"
              v-on:click.prevent="saveOccupant"
            >
              <i class="icon icon-save"></i> Save
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from './../../../Shared/PageHeader.vue';

export default {
  components: {
    PageHeader
  },

  props: {
    incident: {
      type: String,
      required: true
    },
    occupant: {
      type: String
    }
  },

  data() {
    return {
      types: [],
      positions: [],
      occupantData: null,
      form: new window.Form({
        type_id: null,
        first_name: null,
        last_name: null,
        date_of_birth: null,
        occupation: null,
        medical_conditions: null,
        relation_to_client: null,
        national_insurance: null,
        position_id: null,
        requires_glasses: null,
        wearing_seatbelt: null,
        telephone: null,
        email_address: null,
        address_line_one: null,
        address_line_two: null,
        city: null,
        postcode: null
      }),
      indicator: false
    };
  },

  mounted() {
    this.mount();
  },

  computed: {
    address() {
      return {
        address_line_one: this.form.address_line_one,
        address_line_two: this.form.address_line_two,
        city: this.form.city,
        postcode: this.form.postcode
      };
    }
  },

  methods: {
    mount() {
      if (this.occupant) {
        window.Ajax.get(
          '/incidents/' + this.incident + '/occupants/' + this.occupant
        )
          .then(response => {
            (this.form.type_id = response.data.type_id),
              (this.form.first_name = response.data.first_name),
              (this.form.last_name = response.data.last_name),
              (this.form.date_of_birth = window.DateManager.format(
                response.data.date_of_birth
              )),
              (this.form.occupation = response.data.occupation),
              (this.form.medical_conditions = response.data.medical_conditions),
              (this.form.relation_to_client = response.data.relation_to_client),
              (this.form.national_insurance = response.data.national_insurance),
              (this.form.position_id = response.data.position_id),
              (this.form.requires_glasses = response.data.requires_glasses),
              (this.form.wearing_seatbelt = response.data.wearing_seatbelt),
              (this.form.telephone = response.data.telephone),
              (this.form.email_address = response.data.email_address),
              (this.form.address_line_one = response.data.address_line_one),
              (this.form.address_line_two = response.data.address_line_two),
              (this.form.city = response.data.city),
              (this.form.postcode = response.data.postcode);
          })
          .catch(error => {});
      }

      window.Ajax.get(`/incidents/${this.incident}/client`)
        .then(response => {
          this.client = response.data;
        })
        .catch(error => {});

      window.Ajax.get('/occupant-types')
        .then(response => {
          this.types = response.data;
        })
        .catch(error => {});

      window.Ajax.get('/seat-positions')
        .then(response => {
          this.positions = response.data;
        })
        .catch(error => {});
    },

    setAddress(address) {
      this.form.address_line_one = address.address_line_one;
      this.form.address_line_two = address.address_line_two;
      this.form.city = address.city;
      this.form.postcode = address.postcode;
    },

    saveOccupant() {
      let url = `/incidents/${this.incident}/occupants`;
      let method = 'post';

      if (this.occupant) {
        url = `${url}/${this.occupant}`;
        method = 'put';
      }

      this.form[method](url)
        .then(response => {
          this.$emit('updated', response);
          this.$router.back();
        })
        .catch(response => {
          window.toastify.error(
            'Error',
            'Sorry, there was an error saving the occupant'
          );
        });
    },

    deleteOccupant() {
      if (this.occupant) {
        window
          .swal({
            title: 'Are you sure?',
            text: 'You cannot undo this',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes'
          })
          .then(confirmed => {
            if (confirmed) {
              this.indicator = true;
              window.Ajax.delete(
                `/incidents/${this.incident}/occupants/${this.occupant}`
              )
                .then(response => {
                  this.$emit('deleted', this.occupant);
                  this.indicator = false;
                  this.$router.back();
                })
                .catch(error => {
                  this.indicator = false;
                  window.toastify.error(
                    'Error',
                    'Sorry, there was an error deleting the occupant.'
                  );
                });
            }
          })
          .catch(error => {});
      }
    },

    cancel() {
      window
        .swal({
          title: 'Are you sure?',
          text: 'You will lose any unsaved changes',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes'
        })
        .then(confirmed => {
          if (confirmed) {
            this.$emit('close');
          }
          this.$router.back();
        })
        .catch(error => {});
    }
  }
};
</script>
